// アプリ下のボタンに被らいスペース
export const APP_BOTTOM_BUTTON_SPACE = 120;
